import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { pickupOffersService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'pickupOffers',
  initialState: adapter.getInitialState({
    busy: false,
    data: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setPickupOffers: (state, { payload }) => ({ ...state, data: payload }),
    clearPickupOffers: (state) => ({ ...state, data: [] }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchPickupBuyOffers = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await pickupOffersService.fetchPickupBuyOffers(params);
    dispatch(slice.actions.setPickupOffers(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchPickupBuyOffers,
};

export { actions };

export default slice.reducer;
